import React, { useState } from 'react';
import '../Auth/Auth.css';

interface SubscriptionContractModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  plan: {
    id: string;
    name: string;
    price: string;
    duration: string;
  } | null;
  loading?: boolean;
}

const SubscriptionContractModal: React.FC<SubscriptionContractModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  plan,
  loading = false
}) => {
  const [preInfoAccepted, setPreInfoAccepted] = useState(false);
  const [contractAccepted, setContractAccepted] = useState(false);
  const [activeTab, setActiveTab] = useState<'summary' | 'preinfo' | 'contract'>('summary');

  if (!isOpen || !plan) return null;

  const canProceed = preInfoAccepted && contractAccepted;

  return (
    <div className="kvkk-modal-backdrop" onClick={onClose} style={{ zIndex: 99999 }}>
      <div 
        className="kvkk-modal-content" 
        onClick={(e) => e.stopPropagation()} 
        style={{ maxWidth: '720px', width: '92%', maxHeight: '90vh', display: 'flex', flexDirection: 'column' }}
      >
        <div className="kvkk-header" style={{ padding: '16px 20px', borderBottom: '1px solid #e2e8f0' }}>
          <div>
            <h3 style={{ margin: 0, fontSize: '1.2rem', color: '#0f172a' }}>
              🛡️ Abonelik Onayı ve Yasal Bilgilendirme
            </h3>
            <span style={{ fontSize: '0.85rem', color: '#64748b' }}>
              Seçilen Paket: <strong style={{ color: '#2563eb' }}>{plan.name} ({plan.price} / {plan.duration})</strong>
            </span>
          </div>
          <button className="kvkk-close-btn" onClick={onClose} disabled={loading}>✕</button>
        </div>

        {/* Tab Butonları */}
        <div style={{ display: 'flex', borderBottom: '1px solid #e2e8f0', backgroundColor: '#f8fafc', padding: '0 12px' }}>
          <button
            type="button"
            onClick={() => setActiveTab('summary')}
            style={{
              padding: '10px 16px',
              border: 'none',
              background: 'none',
              borderBottom: activeTab === 'summary' ? '2px solid #2563eb' : '2px solid transparent',
              color: activeTab === 'summary' ? '#2563eb' : '#64748b',
              fontWeight: activeTab === 'summary' ? '600' : '400',
              cursor: 'pointer',
              fontSize: '0.88rem'
            }}
          >
            📋 Sipariş Özeti
          </button>
          <button
            type="button"
            onClick={() => setActiveTab('preinfo')}
            style={{
              padding: '10px 16px',
              border: 'none',
              background: 'none',
              borderBottom: activeTab === 'preinfo' ? '2px solid #2563eb' : '2px solid transparent',
              color: activeTab === 'preinfo' ? '#2563eb' : '#64748b',
              fontWeight: activeTab === 'preinfo' ? '600' : '400',
              cursor: 'pointer',
              fontSize: '0.88rem'
            }}
          >
            📄 1. Ön Bilgilendirme Formu
          </button>
          <button
            type="button"
            onClick={() => setActiveTab('contract')}
            style={{
              padding: '10px 16px',
              border: 'none',
              background: 'none',
              borderBottom: activeTab === 'contract' ? '2px solid #2563eb' : '2px solid transparent',
              color: activeTab === 'contract' ? '#2563eb' : '#64748b',
              fontWeight: activeTab === 'contract' ? '600' : '400',
              cursor: 'pointer',
              fontSize: '0.88rem'
            }}
          >
            ⚖️ 2. Mesafeli Satış Sözleşmesi
          </button>
        </div>

        {/* Tab İçerikleri */}
        <div className="kvkk-body" style={{ flex: 1, overflowY: 'auto', padding: '20px', fontSize: '0.88rem', lineHeight: '1.6', color: '#334155' }}>
          {activeTab === 'summary' && (
            <div>
              <div style={{ backgroundColor: '#f1f5f9', padding: '16px', borderRadius: '8px', marginBottom: '16px' }}>
                <h4 style={{ margin: '0 0 10px 0', color: '#0f172a' }}>Paket Sipariş Detayları</h4>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px', fontSize: '0.9rem' }}>
                  <div><strong>Hizmet:</strong> Uzman Destek SaaS Yazılım Lisansı</div>
                  <div><strong>Plan:</strong> {plan.name}</div>
                  <div><strong>Süre:</strong> {plan.duration}</div>
                  <div><strong>Toplam Tutar:</strong> <span style={{ color: '#16a34a', fontWeight: 'bold', fontSize: '1.1rem' }}>{plan.price}</span></div>
                </div>
              </div>

              <div style={{ backgroundColor: '#eff6ff', border: '1px solid #bfdbfe', padding: '14px', borderRadius: '8px', marginBottom: '16px' }}>
                <p style={{ margin: 0, fontSize: '0.85rem', color: '#1e40af' }}>
                  ℹ️ <strong>Yasal Bilgilendirme:</strong> Talebinizi onayladıktan sonra banka hesap bilgileri ve ödeme sonrası anında devreye girecek aktivasyon kodunuz size iletilecektir.
                </p>
              </div>

              <p style={{ fontSize: '0.85rem', color: '#64748b' }}>
                Lütfen yukarıdaki sekmelerden <strong>Ön Bilgilendirme Formu</strong> ve <strong>Mesafeli Satış Sözleşmesi</strong>'ni inceleyiniz. Sipariş talebinizi iletebilmek için aşağıdaki onay kutularını işaretlemeniz gerekmektedir.
              </p>
            </div>
          )}

          {activeTab === 'preinfo' && (
            <div>
              <h4 style={{ color: '#0f172a', marginTop: 0 }}>ÖN BİLGİLENDİRME FORMU</h4>
              <p>
                <strong>1. HİZMET SAĞLAYICI:</strong><br />
                Uzman Destek Yazılım ve Bilişim Hizmetleri (Portal Sağlayıcı).<br />
                İletişim: destek@uzmandestek.com | WhatsApp: 0507 213 64 74
              </p>
              <p>
                <strong>2. HİZMETİN NİTELİĞİ VE KAPSAMI:</strong><br />
                İşbu hizmet; bağımsız İSG uzmanlarının işyerlerini manuel kaydetmelerini, ziyaret ve saha denetimlerini, risk analizi şablonlarını ve mevzuat süreçlerini yönetmelerini sağlayan Web ve Mobil PWA tabanlı bulut yazılım kullanım lisansıdır.
              </p>
              <p>
                <strong>3. GEÇERLİLİK VE ÖDEME:</strong><br />
                Belirtilen paket ücreti ({plan.price}), seçilen süre ({plan.duration}) boyunca geçerli olup vergiler dahildir.
              </p>
              <p>
                <strong>4. CAYMA HAKKI İSTİSNASI (ÖNEMLİ):</strong><br />
                6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği m. 15/1-ğ bendi uyarınca; <em>"Elektronik ortamda anında ifa edilen hizmetler veya tüketiciye anında teslim edilen gayrimaddi mallara ilişkin sözleşmelerde"</em> <strong>cayma hakkı bulunmamaktadır</strong>. Kullanıcı, aktivasyon kodu veya onay ile lisans başladığında bu haktan feragat ettiğini peşinen kabul eder.
              </p>
            </div>
          )}

          {activeTab === 'contract' && (
            <div>
              <h4 style={{ color: '#0f172a', marginTop: 0 }}>MESAFELİ SATIŞ VE LİSANS SÖZLEŞMESİ</h4>
              <p>
                <strong>MADDE 1 - TARAFLAR:</strong><br />
                İşbu Sözleşme, Uzman Destek (Hizmet Sağlayıcı) ile portala kayıt olarak işbu elektronik sözleşmeyi onaylayan Kullanıcı (Alıcı / Uzman) arasında akdedilmiştir.
              </p>
              <p>
                <strong>MADDE 2 - SÖZLEŞMENİN KONUSU:</strong><br />
                Alıcı'nın Hizmet Sağlayıcı'ya ait platform üzerinden seçtiği "{plan.name}" yazılım lisansı hizmetinin satışı, teslimi ve tarafların hak ve yükümlülükleridir.
              </p>
              <p>
                <strong>MADDE 3 - HİZMETİN İFASI VE KULLANIM ŞARTLARI:</strong><br />
                3.1. Hizmet, aktivasyon kodunun sisteme girilmesi veya sistem yöneticisi tarafından paketin onaylanması ile derhal başlar.<br />
                3.2. Kullanıcı, hesap giriş bilgilerinin güvenliğinden bizzat sorumludur. Hesabın üçüncü kişilere devredilmesi yasaktır.<br />
                3.3. Sistemde tutulan müşteri/işyeri verileri <strong>AES-256-GCM</strong> çift yönlü şifreleme ile muhafaza edilir.
              </p>
              <p>
                <strong>MADDE 4 - SORUMLULUK SINIRLAMASI (MÜCBİR SEBEPLER):</strong><br />
                Devlet kurumları (İSG-KÂTİP, Bakanlık sunucuları), telekomünikasyon altyapı arızaları veya siber saldırılardan kaynaklanan mücbir sebep niteliğindeki geçici erişim aksaklıklarından Hizmet Sağlayıcı mali ve hukuki olarak sorumlu tutulamaz.
              </p>
              <p>
                <strong>MADDE 5 - CAYMA HAKKI:</strong><br />
                Mesafeli Sözleşmeler Yönetmeliği m.15/1-ğ uyarınca elektronik ortamda anında teslim edilen gayrimaddi hak niteliğindeki SaaS lisanslarında cayma hakkı bulunmamaktadır.
              </p>
              <p>
                <strong>MADDE 6 - YETKİLİ MAHKEME:</strong><br />
                İşbu sözleşmeden doğan uyuşmazlıklarda Hizmet Sağlayıcı'nın yerleşim yeri Tüketici Hakem Heyetleri ve Mahkemeleri yetkilidir.
              </p>
            </div>
          )}
        </div>

        {/* Onay Checkbox'ları ve Alt Butonlar */}
        <div style={{ borderTop: '1px solid #e2e8f0', padding: '16px 20px', backgroundColor: '#f8fafc', position: 'relative', zIndex: 10 }}>
          <div style={{ marginBottom: '10px' }}>
            <label 
              onClick={(e) => {
                if ((e.target as HTMLElement).tagName !== 'BUTTON') {
                  setPreInfoAccepted(!preInfoAccepted);
                }
              }}
              style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer', fontSize: '0.85rem', color: '#1e293b', userSelect: 'none' }}
            >
              <input
                type="checkbox"
                checked={preInfoAccepted}
                onChange={(e) => setPreInfoAccepted(e.target.checked)}
                style={{ marginTop: '3px', cursor: 'pointer', width: '16px', height: '16px' }}
              />
              <span>
                <button 
                  type="button" 
                  onClick={(e) => { e.stopPropagation(); setActiveTab('preinfo'); }} 
                  style={{ background: 'none', border: 'none', color: '#2563eb', textDecoration: 'underline', padding: 0, font: 'inherit', cursor: 'pointer' }}
                >
                  Ön Bilgilendirme Formu
                </button>
                'nu okudum, hizmet kapsamını ve cayma hakkı istisnasını kabul ediyorum. *
              </span>
            </label>
          </div>

          <div style={{ marginBottom: '14px' }}>
            <label 
              onClick={(e) => {
                if ((e.target as HTMLElement).tagName !== 'BUTTON') {
                  setContractAccepted(!contractAccepted);
                }
              }}
              style={{ display: 'flex', alignItems: 'flex-start', gap: '8px', cursor: 'pointer', fontSize: '0.85rem', color: '#1e293b', userSelect: 'none' }}
            >
              <input
                type="checkbox"
                checked={contractAccepted}
                onChange={(e) => setContractAccepted(e.target.checked)}
                style={{ marginTop: '3px', cursor: 'pointer', width: '16px', height: '16px' }}
              />
              <span>
                <button 
                  type="button" 
                  onClick={(e) => { e.stopPropagation(); setActiveTab('contract'); }} 
                  style={{ background: 'none', border: 'none', color: '#2563eb', textDecoration: 'underline', padding: 0, font: 'inherit', cursor: 'pointer' }}
                >
                  Mesafeli Satış ve Lisans Sözleşmesi
                </button>
                'ni okudum, şartları onaylıyorum. *
              </span>
            </label>
          </div>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              style={{
                padding: '9px 18px',
                border: '1px solid #cbd5e1',
                borderRadius: '6px',
                backgroundColor: '#ffffff',
                color: '#475569',
                cursor: 'pointer',
                fontSize: '0.9rem'
              }}
            >
              Vazgeç
            </button>
            <button
              type="button"
              onClick={onConfirm}
              disabled={!canProceed || loading}
              style={{
                padding: '9px 24px',
                border: 'none',
                borderRadius: '6px',
                backgroundColor: canProceed ? '#2563eb' : '#94a3b8',
                color: '#ffffff',
                cursor: canProceed && !loading ? 'pointer' : 'not-allowed',
                fontWeight: '600',
                fontSize: '0.9rem',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              {loading ? 'İşleniyor...' : 'Talebi Onayla ve Devam Et 🚀'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionContractModal;
